export const LOGIN_API = '/login';
export const USER_API = '/users';
export const PERMISSION_API = `/roles`;
export const USER_PERMISSION_API = `/getModules`;
export const LOGIN_WITH_PHONE_API = `/generateOTP`
export const LOGIN_WITH_VALIDATE_API = `/validateOTP`